import { config } from "../../../config/config";

export interface SaleLineDetail {
  name: string;
  quantity: number;
}

export interface PlanSaleDetail {
  clientName: string;
  planName: string;
  items?: SaleLineDetail[];
  amount: number;
  time: string;
}

export interface FoodSaleDetail {
  clientName: string;
  foodName: string;
  items?: SaleLineDetail[];
  amount: number;
  time: string;
}

export interface MerchandiseSaleDetail {
  clientName: string;
  productName: string;
  items?: SaleLineDetail[];
  amount: number;
  time: string;
}

export type DailySale =
  | ({ type: "plan" } & PlanSaleDetail)
  | ({ type: "food" } & FoodSaleDetail)
  | ({ type: "merchandise" } & MerchandiseSaleDetail);

export interface DailySalesData {
  reportDate: string;
  totalRevenue: number;
  planSales: {
    sales: PlanSaleDetail[];
    totalAmount: number;
  };
  foodSales: {
    sales: FoodSaleDetail[];
    totalAmount: number;
  };
  merchandiseSales: {
    sales: MerchandiseSaleDetail[];
    totalAmount: number;
  };
}

export const getDailySalesRequest = async (
  token: string,
): Promise<DailySalesData> => {
  const response = await fetch(`${config.API_URL}/metrics/daily-sales`, {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    },
  });

  if (!response.ok) {
    if (response.status === 403) {
      throw new Error("No tienes permisos para obtener las ventas diarias");
    }
    if (response.status === 401) {
      throw new Error("No autorizado");
    }
    throw new Error(
      response.statusText || "Error al obtener las ventas diarias",
    );
  }

  return (await response.json()) as DailySalesData;
};
